import { Modal, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Trans } from 'react-i18next';

export default function MayoristaModal({ show, handleClose }) {
    const { t } = useTranslation();

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{t('modalmayoristatitutlo')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
    

<div className="mb-4">
  <p className="pnegro">
    <strong>{t('wholesale.greeting')}</strong>
  </p>
  
  <p className="pnegro">
    {/* Usamos Trans solo donde hay HTML dentro del texto (el <em>) */}
    <Trans 
      i18nKey="wholesale.question" 
      components={{ em: <em /> }} 
    />
  </p>
  
  <p className="pnegro">
    {t('wholesale.register')}
  </p>
  
  <p className="pnegro">
    {t('wholesale.whatsapp')}
  </p>
</div>

        <Button 
          variant="success" 
          href="https://b2b.kitsunegames.ar" 
          target="_blank" 
          rel="noopener noreferrer"
          className="w-100"
          onClick={handleClose}
        >
          {t('modalmayoristabtn')}
        </Button>
      </Modal.Body>
    </Modal>
  );
}